// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/home/baboo/Documents/projets/privilege-revival/front/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-tsx": () => import("/home/baboo/Documents/projets/privilege-revival/front/src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

